import { render, staticRenderFns } from "./PickupInfo.vue?vue&type=template&id=3023587c&scoped=true&"
import script from "./PickupInfo.vue?vue&type=script&lang=js&"
export * from "./PickupInfo.vue?vue&type=script&lang=js&"
import style0 from "./PickupInfo.vue?vue&type=style&index=0&id=3023587c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023587c",
  null
  
)

export default component.exports